// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);
}

.public-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3rem;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: var(--shadow-md);
  position: sticky;
  top: 0;
  z-index: 100;
}

.logo {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-img {
  height: 50px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  transition: transform 0.3s ease;
}

.logo-img:hover {
  transform: scale(1.05);
}

.logo h1 {
  font-size: 1.75rem;
  color: var(--primary-color);
  font-weight: 700;
  letter-spacing: -0.5px;
}

.logo-subtitle {
  font-size: 0.875rem;
  color: var(--secondary-color);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.search-container {
  flex: 1 1;
  max-width: 600px;
  margin: 0 2rem;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 1rem 1.5rem 1rem 3rem;
  border: 2px solid transparent;
  border-radius: 9999px;
  font-size: 1rem;
  background: var(--white);
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  outline: none;
}

.search-input:focus {
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);
}

.search-icon {
  position: absolute;
  left: 1.2rem;
  font-size: 1.2rem;
  color: var(--text-light);
}

.search-help {
  text-align: center;
  font-size: 0.75rem;
  color: var(--text-light);
  margin-top: 0.5rem;
}

.admin-access .admin-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: var(--white);
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
}

.admin-access .admin-link:hover {
  background-color: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.public-main {
  flex: 1 1;
  padding: 4rem 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.table-wrapper {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: var(--radius-xl);
  padding: 2rem;
  box-shadow: var(--shadow-lg);
  animation: fadeIn 0.6s ease forwards;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.table-header h2 {
  font-size: 1.5rem;
  color: var(--primary-color);
  font-weight: 600;
}

.guest-count {
  background: rgba(245, 158, 11, 0.1);
  color: var(--secondary-hover);
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.875rem;
}

.table-responsive {
  overflow-x: auto;
}

.guest-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.guest-table th {
  text-align: left;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: var(--text-light);
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
}

.guest-table td {
  padding: 1.25rem 1.5rem;
  color: var(--text-dark);
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.guest-table tbody tr:hover td {
  background: rgba(255, 255, 255, 0.5);
}

.guest-table tbody tr:last-child td {
  border-bottom: none;
}

.seq {
  font-weight: 600;
  color: var(--text-light);
}

.passport {
  font-family: monospace;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--primary-color);
}

.room {
  font-weight: 600;
  color: var(--secondary-color);
}

.loading {
  text-align: center;
  padding: 4rem;
  color: var(--text-light);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(245, 158, 11, 0.2);
  border-top-color: var(--secondary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.public-footer {
  background: var(--white);
  padding: 2rem;
  text-align: center;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.public-footer p {
  color: var(--text-light);
  font-size: 0.875rem;
}

.footer-note {
  margin-top: 0.5rem;
  font-weight: 500;
  color: var(--primary-color) !important;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .public-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  .logo {
    flex-direction: column;
    text-align: center;
  }
  .search-container {
    width: 100%;
    margin: 0;
  }
  .admin-access {
    width: 100%;
  }
  .admin-link {
    justify-content: center;
  }
  .public-main {
    padding: 2rem 1rem;
  }
  .table-wrapper {
    padding: 1rem;
  }
  .table-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  .guest-table th, .guest-table td {
    padding: 1rem 0.5rem;
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/PublicPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,iDAAiD;EACjD,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,4CAA4C;EAC5C,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":[".public-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);\n}\n\n.public-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 3rem;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(16px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: var(--shadow-md);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.logo-img {\n  height: 50px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.3s ease;\n}\n\n.logo-img:hover {\n  transform: scale(1.05);\n}\n\n.logo h1 {\n  font-size: 1.75rem;\n  color: var(--primary-color);\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.logo-subtitle {\n  font-size: 0.875rem;\n  color: var(--secondary-color);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.search-container {\n  flex: 1;\n  max-width: 600px;\n  margin: 0 2rem;\n}\n\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-input {\n  width: 100%;\n  padding: 1rem 1.5rem 1rem 3rem;\n  border: 2px solid transparent;\n  border-radius: 9999px;\n  font-size: 1rem;\n  background: var(--white);\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.search-input:focus {\n  border-color: var(--secondary-color);\n  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 1.2rem;\n  font-size: 1.2rem;\n  color: var(--text-light);\n}\n\n.search-help {\n  text-align: center;\n  font-size: 0.75rem;\n  color: var(--text-light);\n  margin-top: 0.5rem;\n}\n\n.admin-access .admin-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: var(--primary-color);\n  color: var(--white);\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s ease;\n}\n\n.admin-access .admin-link:hover {\n  background-color: var(--secondary-color);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.public-main {\n  flex: 1;\n  padding: 4rem 2rem;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.table-wrapper {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: var(--radius-xl);\n  padding: 2rem;\n  box-shadow: var(--shadow-lg);\n  animation: fadeIn 0.6s ease forwards;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.table-header h2 {\n  font-size: 1.5rem;\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.guest-count {\n  background: rgba(245, 158, 11, 0.1);\n  color: var(--secondary-hover);\n  padding: 0.5rem 1rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.guest-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.guest-table th {\n  text-align: left;\n  padding: 1rem 1.5rem;\n  font-weight: 600;\n  color: var(--text-light);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.05);\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 1px;\n}\n\n.guest-table td {\n  padding: 1.25rem 1.5rem;\n  color: var(--text-dark);\n  font-size: 0.95rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.guest-table tbody tr:hover td {\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.guest-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.seq {\n  font-weight: 600;\n  color: var(--text-light);\n}\n\n.passport {\n  font-family: monospace;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: var(--primary-color);\n}\n\n.room {\n  font-weight: 600;\n  color: var(--secondary-color);\n}\n\n.loading {\n  text-align: center;\n  padding: 4rem;\n  color: var(--text-light);\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(245, 158, 11, 0.2);\n  border-top-color: var(--secondary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.public-footer {\n  background: var(--white);\n  padding: 2rem;\n  text-align: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.public-footer p {\n  color: var(--text-light);\n  font-size: 0.875rem;\n}\n\n.footer-note {\n  margin-top: 0.5rem;\n  font-weight: 500;\n  color: var(--primary-color) !important;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .public-header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n  .logo {\n    flex-direction: column;\n    text-align: center;\n  }\n  .search-container {\n    width: 100%;\n    margin: 0;\n  }\n  .admin-access {\n    width: 100%;\n  }\n  .admin-link {\n    justify-content: center;\n  }\n  .public-main {\n    padding: 2rem 1rem;\n  }\n  .table-wrapper {\n    padding: 1rem;\n  }\n  .table-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n  .guest-table th, .guest-table td {\n    padding: 1rem 0.5rem;\n    font-size: 0.85rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
